import * as types from './actionTypes';
import {apiRequest, apiPost, apiDelete} from '../utils/request';
import {toastr} from 'react-redux-toastr';
import {savingClient} from "./clientActions";
import { getErrorMessage } from '../utils/lib';

export function deviceLocationSuccess(deviceLocation){
  return {type: types.DEVICE_LOCATION_SUCCESS, deviceLocation};
}

export function setDeviceLocation(deviceLocation) {
  return function (dispatch) {
      dispatch(deviceLocationSuccess(deviceLocation));
  };
}

export function loadLocationsSuccess(locations){
  return {type: types.LOAD_LOCATIONS_SUCCESS, locations};
}

export function saveLocationSuccess(location, isNew){
  return {type: types.SAVE_LOCATION_SUCCESS, location, isNew};
}

export function saveLocationError(saveError){
  return {type: types.SAVE_LOCATION_ERROR, saveError};
}

export function savingLocation(location) {
  return {
    type: types.SAVE_LOCATION_SAVING,
    saveInfo: {
      location,
      saving: true,
      saved: false,
      isNew: false,
    }
  };
}


export function loadLocations(name, clear=false, excludeInactive=false) {
  return function (dispatch) {

    if (!clear) {
      dispatch(loadLocationsSuccess({loaded: false, items: [], isNew: false,}));
      return apiRequest(`/api/manageLocations?searchName=${name}&excludeInactive=${excludeInactive}`)
        .then(x => {
          if (x.error || x.data.Message) {
            toastr.error(`Error while fetching locations, error: ${x.error ? x.error : x.data.Message}`);
            return dispatch(loadLocationsSuccess({loaded: true, items: []}));
          } else {
           return dispatch(loadLocationsSuccess({loaded: true, items: Array.from(x.data)}));
          }
        });
    } else {
     return dispatch(loadLocationsSuccess({loaded: true, items: [], isNew: false}));
    }
  };
}


export function saveLocation(location) {
  return function (dispatch) {
    let isNew = location.id < 0;
    toastr.success('Saving Location');

    if(location.collectionWasteFactor === '' ||
      location.collectionWasteFactor === null ||
      isNaN(location.collectionWasteFactor)) {
      location = {...location, collectionWasteFactor: 10};
    }

    dispatch(savingLocation(location));
    return apiPost(`/api/manageLocations/${location.id}`, location)
      .then(x => {
        if (x.error || x.data.Message) {
          toastr.error(getErrorMessage({x}));
          dispatch(saveLocationError({error: getErrorMessage({x}), location}));
        } else {
          dispatch(saveLocationSuccess(x.data, isNew));
        }
      });
  };
}
